import styled from "styled-components"

import tokens from "../_tokens"

const List = styled.ul`
  padding-left: 2em;

  ul,
  ol {
    margin-top: 0;
    margin-bottom: 0;
  }

  li {
    word-wrap: break-all;
  }

  li > p {
    margin-top: ${1.5 * tokens.size.base}px;
  }

  li + li {
    margin-top: ${0.5 * tokens.size.base}px;
  }
`

export default List
